module.exports = __webpack_public_path__ + "static/media/Silver-2013-cabernet-sauvignon.dada8050.jpg";